var map = {
	"./arrow-right.svg": 5555,
	"./chevron-down.svg": 3698,
	"./chevron-right.svg": 260,
	"./chevron-up.svg": 2352,
	"./digitalization.svg": 9764,
	"./download-cloud.svg": 8791,
	"./envelope.svg": 3219,
	"./interoperability.svg": 6495,
	"./location.svg": 9668,
	"./logo.svg": 467,
	"./medicalc.svg": 1654,
	"./mex.svg": 9689,
	"./mlabs.svg": 7376,
	"./mmobile.svg": 3443,
	"./mobility.svg": 4099,
	"./mpacs.svg": 3888,
	"./mpatient.svg": 3336,
	"./paperless.svg": 824,
	"./phone.svg": 3694,
	"./send.svg": 3410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2064;